import { AnalyticsTracker, CookieConsentBanner, ReactivationNotice, ScrollToTop } from "components";
import React from "react";

import MainRouter from "./MainRouter";
import { SessionProvider } from "./Session";

const App = () => {
	return (
		<SessionProvider>
			<MainRouter />
			<ReactivationNotice />
			<ScrollToTop />
			<AnalyticsTracker />
			<CookieConsentBanner />
		</SessionProvider>
	);
};

export default App;
